export default __webpack_public_path__ + "static/media/category_create.e283cd2b.svg";